var _require = require('../categories'),
  STORE_CATEGORIES = _require.STORE_CATEGORIES,
  STORE_CATEGORY_LIST = _require.STORE_CATEGORY_LIST,
  categoryViewKey = _require.categoryViewKey;
function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/** Public marketplace sidebar — All Listings is a normal category row. */
function browseTemplate() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$showMyStore = _ref.showMyStore,
    showMyStore = _ref$showMyStore === void 0 ? false : _ref$showMyStore;
  var categoryItems = STORE_CATEGORY_LIST.map(function (category) {
    var view = categoryViewKey(category);
    return "<li class=\"item\" role=\"button\" tabindex=\"0\" data-view=\"".concat(view, "\" data-category=\"").concat(escapeHtml(category), "\">").concat(escapeHtml(category), "</li>");
  }).join('\n      ');
  var footerItem = showMyStore ? "<li class=\"item\" role=\"button\" tabindex=\"0\" data-view=\"my-store\">My Saito Store</li>" : "<li class=\"item\" role=\"button\" tabindex=\"0\" data-action=\"list-item\">List Item for Sale</li>";
  return "\n    <ul class=\"list saito-menu-select-subtle\" role=\"list\">\n      <li class=\"item moderation-item\" id=\"store-menu-moderate\" hidden role=\"button\" tabindex=\"-1\" data-view=\"moderation\" aria-hidden=\"true\">\n        <span class=\"label\">Moderate</span>\n        <span class=\"saito-notification-dot badge\" data-moderation-count aria-hidden=\"true\">0</span>\n      </li>\n      <li class=\"item active\" role=\"button\" tabindex=\"0\" data-view=\"all\" data-category=\"\">All Listings</li>\n      ".concat(categoryItems, "\n      <li class=\"divider\" role=\"separator\"></li>\n      ").concat(footerItem, "\n    </ul>\n  ");
}

/** Seller admin sidebar — Admin Home with indented children + View Store. */
function dashboardTemplate() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$dashboardView = _ref2.dashboardView,
    dashboardView = _ref2$dashboardView === void 0 ? 'store-admin' : _ref2$dashboardView,
    _ref2$showWithdrawals = _ref2.showWithdrawals,
    showWithdrawals = _ref2$showWithdrawals === void 0 ? false : _ref2$showWithdrawals;
  var view = ['store-admin', 'active', 'sold', 'withdrawals'].includes(dashboardView) ? dashboardView : 'store-admin';
  var item = function item(id, label) {
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$child = _ref3.child,
      child = _ref3$child === void 0 ? false : _ref3$child;
    var on = view === id;
    var active = on ? ' active' : '';
    var current = on ? 'page' : 'false';
    var childClass = child ? ' child' : '';
    var caret = child ? "<span class=\"caret\" aria-hidden=\"true\">&gt;</span>" : '';
    return "<li class=\"item".concat(childClass).concat(active, "\" role=\"button\" tabindex=\"0\" data-view=\"").concat(id, "\" aria-current=\"").concat(current, "\">").concat(caret, "<span class=\"label\">").concat(label, "</span></li>");
  };
  return "\n    <ul class=\"list saito-menu-select-subtle\" role=\"list\">\n      ".concat(item('store-admin', 'Admin Home'), "\n      ").concat(item('active', 'Listings', {
    child: true
  }), "\n      ").concat(item('sold', 'Sales', {
    child: true
  }), "\n      ").concat(showWithdrawals ? item('withdrawals', 'Withdrawals', {
    child: true
  }) : '', "\n      <li class=\"item child\" role=\"button\" tabindex=\"0\" data-action=\"settings\">\n        <span class=\"caret\" aria-hidden=\"true\">&gt;</span>\n        <span class=\"label\">Settings</span>\n      </li>\n      <li class=\"item\" role=\"button\" tabindex=\"0\" data-view=\"view-store\">\n        <span class=\"label\">View Store</span>\n      </li>\n    </ul>\n  ");
}
module.exports = browseTemplate;
module.exports.browse = browseTemplate;
module.exports.dashboard = dashboardTemplate;
module.exports.STORE_CATEGORIES = STORE_CATEGORIES;
module.exports.STORE_CATEGORY_LIST = STORE_CATEGORY_LIST;
module.exports.categoryViewKey = categoryViewKey;